module.exports = __webpack_public_path__ + "static/img/icon_code_05.b4385e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/index/icon_code_05.png
// module id = RH/2
// module chunks = 11